import { render, staticRenderFns } from "./CertificatesAdmin.vue?vue&type=template&id=41ef472b"
import script from "./CertificatesAdmin.vue?vue&type=script&lang=js"
export * from "./CertificatesAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports